import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

const FieldRendererBoolean = ({ name, property, field, isRequired }) => {
  const label = name.charAt(0).toUpperCase() + name.slice(1);
  
  return (
    <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
      <FormControl>
        <Checkbox
          checked={field.value}
          onCheckedChange={field.onChange}
        />
      </FormControl>
      <div className="space-y-1 leading-none">
        <FormLabel>
          {property.label}
          {isRequired && ' *'}
        </FormLabel>
        {property.description && (
          <FormDescription>{property.description}</FormDescription>
        )}
      </div>
      <FormMessage />
    </FormItem>
  );
};

export default FieldRendererBoolean;